import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../services/api';
import { FinCheck } from '../FinField';
import { estadoClientePagou } from './adiantamentoClientePagouPolicy';

// "Adiantamento já feito" (D-0120): mesma forma da marcação da D-0098 (PagamentoLegadoParcela).
// `adiantamento` precisa de parcela_id|id, cliente_ja_pagou, situacao, status_pagamento.
export default function AdiantamentoClientePagou({ adiantamento, perfil, onAtualizado }) {
    const [marcado, setMarcado] = useState(!!adiantamento?.cliente_ja_pagou);
    const [salvando, setSalvando] = useState(false);
    useEffect(() => { setMarcado(!!adiantamento?.cliente_ja_pagou); }, [adiantamento?.cliente_ja_pagou]);
    const estado = estadoClientePagou(adiantamento ? { ...adiantamento, cliente_ja_pagou: marcado } : null, perfil);
    if (!estado || (!estado.marcado && !estado.editavel)) return null;
    const parcelaId = adiantamento.parcela_id || adiantamento.id;

    const alterar = async (valor) => {
        if (salvando || !estado.editavel) return;
        setSalvando(true);
        try {
            const res = await api({ method: 'put',
                action: `/financeiroParcela/${parcelaId}/clienteJaPagou`,
                token: localStorage.getItem('token'), data: { marcado: valor } });
            const confirmado = res.data?.data;
            if (!res.data?.status || !confirmado) throw new Error(res.data?.error || 'Não foi possível salvar a marcação.');
            setMarcado(!!confirmado.cliente_ja_pagou);
            if (onAtualizado) onAtualizado(!!confirmado.cliente_ja_pagou);
        } catch (e) {
            toast.error(e.response?.data?.error || e.message || 'Não foi possível salvar a marcação.');
        } finally {
            setSalvando(false);
        }
    };

    return (
        <div className="fin-pp__legado" data-cliente-ja-pagou={marcado ? 'sim' : 'nao'} aria-busy={salvando} onClick={e => e.stopPropagation()}>
            {marcado && <span className="fin-pp__pill is-warn">Adiantamento já feito</span>}
            {estado.editavel && (
                <FinCheck label={salvando ? 'Salvando…' : 'Adiantamento já feito (cliente já pagou)'}
                    checked={marcado} disabled={salvando} onChange={e => alterar(e.target.checked)} />
            )}
            {marcado && estado.bloqueio && <div className="fin-pp__cell-muted">{estado.bloqueio}</div>}
        </div>
    );
}
